module.exports = "<!-- \n<div>\n    <strong>This is header</strong>\n</div>\n-->"


//////////////////
// WEBPACK FOOTER
// ./src/app/header/header.component.html
// module id = 644
// module chunks = 0